"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const model_1 = require("@containers/common/model");
const data_1 = require("@containers/common/model/data");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
require("./style.scss");
const Loading = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { apiStatus } = (0, react_redux_1.useSelector)((state) => (Object.assign({}, state.common)));
    // 當fetch失敗關閉loading，並將failed狀態重設為false
    react_1.default.useEffect(() => {
        if (apiStatus.failed)
            dispatch((0, model_1.SET_API_STATUS)(Object.assign(Object.assign({}, apiStatus), { failed: false })));
    }, [apiStatus.failed]);
    // 待任一component再次打開loading時，重設apiStatus
    react_1.default.useEffect(() => {
        dispatch((0, model_1.SET_API_STATUS)(Object.assign(Object.assign({}, data_1.apiStatus), { pending: true })));
        return () => {
            dispatch((0, model_1.SET_API_STATUS)(data_1.apiStatus));
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: apiStatus.pending && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "loading__backdrop" }, { children: [(0, jsx_runtime_1.jsx)("svg", Object.assign({ className: "loading__spinner", width: "65px", height: "65px", viewBox: "0 0 66 66", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("circle", { className: "loading__path", fill: "none", strokeWidth: "5", strokeLinecap: "round", cx: "33", cy: "33", r: "30" }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "loading__label" }, { children: ["Loading ... ", (0, jsx_runtime_1.jsx)("br", {}), "\u5237\u65B0\u9801\u9762\u4E2D ... \u8ACB\u8010\u5FC3\u7B49\u5019"] }))] }))) }));
};
exports.default = Loading;
